export const GOOD = 'GOOD';
export const OKAY = 'OKAY';
export const BAD = 'BAD';
